import { CONSTANTS } from 'config';

export default function () {

  return function version(v = '') {
    if (CONSTANTS.VERSION[v]) {
      return CONSTANTS.VERSION[v].name;
    }
    return '';
  };
}



// WEBPACK FOOTER //
// ./src/filters/version.js